import styled from "styled-components"
import { DeprecatedTab } from "./tab"

export { DeprecatedTab } from "./tab"

const TabsContainer = styled.div`
  display: flex;
  width: fit-content;
  background-color: ${({ theme }) => theme.colors.white};
`

type TabsProps = {
  children?: React.ReactElement<typeof DeprecatedTab> | (React.ReactElement<typeof DeprecatedTab> | undefined)[]
  as?: React.ElementType
} & React.HTMLProps<HTMLDivElement>

export const DeprecatedTabs: React.FC<TabsProps> = ({ children, as, ...props }) => {
  return (
    <TabsContainer role="tablist" as={as} {...props}>
      {children}
    </TabsContainer>
  )
}
